import { makeVar } from '@apollo/client';
import type { Local__NetworkStatus } from 'types/__generated__/graphql-global-types';

export const initialData: Local__NetworkStatus = {
  __typename: 'Local__NetworkStatus',
  online: true,
  retrying: false,
};

export const networkStatusVar = makeVar<Local__NetworkStatus>(initialData);

export const writeNetworkStatus = (networkStatus: Local__NetworkStatus) => {
  networkStatusVar(networkStatus);
};

export const resolvers = {
  Query: {
    networkStatus: () => {
      try {
        return networkStatusVar();
      } catch {
        return initialData;
      }
    },
  },
};
